import CoreBase from '../../services/engines/CoreBase';
import responseHelper from '../../services/ResponseHelper';
import windowManagerService from '../../services/WindowManagerService';

/**
 * NewNoteSaver — maps CreateNoteDlgWidget inputs to a prioUpdater-compatible entry and saves.
 * Inputs come from createEmpty() shape — no rk, stateId, isPinned, viewMode.
 * Those are set to their defaults here before delegating to prioUpdater.
 */
class WindowPositionPublisher extends CoreBase {
    _name = 'WindowPositionPublisher';

    /**
     * @param {object} data - window location data container PosX, PosY, height, width, component
     */
    publish = async (data) => {
        try {
            data.posX = parseInt(data.posX);
            data.posY = parseInt(data.posY);

            data.height = parseInt(data.height);
            data.width = parseInt(data.width);

            const resp = await windowManagerService.postWindowPosition(data);
            if (responseHelper.check(resp, '', `${this._name}.publish`) < 0) {
                //  this.setState({ items: [] });

                const json = JSON.stringify(data);
                this.logDebug('publish', `${resp?.code} - ${json}`);
                return;
            }
        } catch (error) {
            this.logError('save', error.message);
        }
    };
}

const windowPositionPublisher = new WindowPositionPublisher();
export default windowPositionPublisher;
